// Archivo de traducciones para la aplicación

interface Translations {
  [key: string]: {
    validateCode: string;
    proceed: string;
    next: string;
    open: string;
    enterCode: string;
    accessControl: string;
    enterAccessCode: string;
    validating: string;
    locationVerification: string;
    verifyingLocation: string;
    verifying: string;
    doorAccessInstructions: string;
    doorStatus: string;
    backToInstructions: string;
    loading: string;
    processing: string;
    retryInitialLoad: string;
    waitingForSession: string;
    pleaseEnterCode: string;
    codeValidationError: string;
    codeValidInNextHours: string;
    connectionError: string;
    forgetSavedCode: string;
    geolocationNotSupported: string;
    locationAccessError: string;
    locationPermissionDenied: string;
    locationUnavailable: string;
    locationTimeout: string;
    houseImage: string;
    doorOpenSuccess: string;
    doorOpenError: string;
    notFinalDoorError: string;
    sessionContextError: string;
    noInfoAvailable: string;
  };
}

const translations: Translations = {
  // Español
  ES: {
    validateCode: "Validar Código",
    proceed: "Proceder",
    next: "SIGUIENTE",
    open: "ABRIR",
    enterCode: "Ingrese el código",
    accessControl: "Control de Acceso",
    enterAccessCode: "Ingrese el código de acceso para continuar",
    validating: "Validando...",
    locationVerification: "Verificación de Ubicación",
    verifyingLocation: "Estamos verificando que estés frente a la puerta principal.",
    verifying: "Verificando...",
    doorAccessInstructions: "Instrucciones de Acceso",
    doorStatus: "Estado de la Puerta",
    backToInstructions: "Volver a Instrucciones",
    loading: "Cargando...",
    processing: "Procesando...",
    retryInitialLoad: "Reintentar Carga Inicial",
    waitingForSession: "Esperando información de sesión...",
    pleaseEnterCode: "Por favor, ingrese un código",
    codeValidationError: "Error al validar el código",
    codeValidInNextHours: "El código será válido en las próximas horas",
    connectionError: "Error de conexión con el servidor",
    forgetSavedCode: "Olvidar Código Guardado",
    geolocationNotSupported: "La geolocalización no está soportada por su navegador",
    locationAccessError: "No se pudo obtener su ubicación. Por favor, permita el acceso a la ubicación.",
    locationPermissionDenied: "Acceso a la ubicación denegado. Por favor, habilite los permisos de ubicación e inténtelo de nuevo.",
    locationUnavailable: "No se pudo determinar su ubicación. Asegúrese de tener el GPS activado y buena señal.",
    locationTimeout: "La solicitud de ubicación ha expirado. Asegúrese de estar en un lugar con buena señal GPS e inténtelo de nuevo.",
    houseImage: "Casa",
    doorOpenSuccess: "Puerta abierta correctamente",
    doorOpenError: "Error al abrir la puerta. Por favor, intente nuevamente.",
    notFinalDoorError: "Esta no es la puerta final. Por favor, continúe con los siguientes pasos.",
    sessionContextError: "El ID de la casa no está disponible en el contexto de la sesión.",
    noInfoAvailable: "No hay información disponible. Por favor, intente nuevamente."
  },
  // English
  EN: {
    validateCode: "Validate Code",
    proceed: "Proceed",
    next: "NEXT",
    open: "OPEN",
    enterCode: "Enter code",
    accessControl: "Access Control",
    enterAccessCode: "Enter access code to continue",
    validating: "Validating...",
    locationVerification: "Location Verification",
    verifyingLocation: "We are verifying that you are in front of the main door.",
    verifying: "Verifying...",
    doorAccessInstructions: "Door Access Instructions",
    doorStatus: "Door Status",
    backToInstructions: "Back to Instructions",
    loading: "Loading...",
    processing: "Processing...",
    retryInitialLoad: "Retry Initial Load",
    waitingForSession: "Waiting for session information...",
    pleaseEnterCode: "Please enter a code",
    codeValidationError: "Error validating the code",
    codeValidInNextHours: "Code will be valid in the next hours",
    connectionError: "Connection error with the server",
    forgetSavedCode: "Forget Saved Code",
    geolocationNotSupported: "Geolocation is not supported by your browser",
    locationAccessError: "Could not get your location. Please allow location access.",
    locationPermissionDenied: "Location access denied. Please enable location permissions and try again.",
    locationUnavailable: "Your location could not be determined. Make sure GPS is enabled and you have a good signal.",
    locationTimeout: "The location request timed out. Make sure you are in a place with good GPS signal and try again.",
    houseImage: "House",
    doorOpenSuccess: "Door opened successfully",
    doorOpenError: "Error opening the door. Please try again.",
    notFinalDoorError: "This is not the final door. Please continue with the next steps.",
    sessionContextError: "House ID is not available from session context.",
    noInfoAvailable: "No information available. Please try again."
  },
  // Français
  FR: {
    validateCode: "Valider le Code",
    proceed: "Continuer",
    next: "SUIVANT",
    open: "OUVRIR",
    enterCode: "Entrez le code",
    accessControl: "Contrôle d'Accès",
    enterAccessCode: "Entrez le code d'accès pour continuer",
    validating: "Validation en cours...",
    locationVerification: "Vérification de l'Emplacement",
    verifyingLocation: "Nous vérifions que vous êtes devant la porte principale.",
    verifying: "Vérification en cours...",
    doorAccessInstructions: "Instructions d'Accès à la Porte",
    doorStatus: "État de la Porte",
    backToInstructions: "Retour aux Instructions",
    loading: "Chargement...",
    processing: "Traitement en cours...",
    retryInitialLoad: "Réessayer le Chargement Initial",
    waitingForSession: "En attente des informations de session...",
    pleaseEnterCode: "Veuillez entrer un code",
    codeValidationError: "Erreur lors de la validation du code",
    codeValidInNextHours: "Le code sera valide dans les prochaines heures",
    connectionError: "Erreur de connexion avec le serveur",
    forgetSavedCode: "Oublier le Code Enregistré",
    geolocationNotSupported: "La géolocalisation n'est pas prise en charge par votre navigateur",
    locationAccessError: "Impossible d'obtenir votre position. Veuillez autoriser l'accès à la localisation.",
    locationPermissionDenied: "Accès à la localisation refusé. Veuillez activer les autorisations de localisation et réessayer.",
    locationUnavailable: "Votre position n'a pas pu être déterminée. Assurez-vous que le GPS est activé et que le signal est bon.",
    locationTimeout: "La demande de localisation a expiré. Assurez-vous d'être dans un endroit avec un bon signal GPS et réessayez.",
    houseImage: "Maison",
    doorOpenSuccess: "Porte ouverte avec succès",
    doorOpenError: "Erreur lors de l'ouverture de la porte. Veuillez réessayer.",
    notFinalDoorError: "Ce n'est pas la porte finale. Veuillez continuer avec les étapes suivantes.",
    sessionContextError: "L'ID de la maison n'est pas disponible dans le contexte de la session.",
    noInfoAvailable: "Aucune information disponible. Veuillez réessayer."
  },
  // Deutsch
  DE: {
    validateCode: "Code Validieren",
    proceed: "Fortfahren",
    next: "WEITER",
    open: "ÖFFNEN",
    enterCode: "Code eingeben",
    accessControl: "Zugangskontrolle",
    enterAccessCode: "Geben Sie den Zugangscode ein, um fortzufahren",
    validating: "Validierung...",
    locationVerification: "Standortüberprüfung",
    verifyingLocation: "Wir überprüfen, ob Sie vor der Haupttür stehen.",
    verifying: "Überprüfung...",
    doorAccessInstructions: "Türzugangsanweisungen",
    doorStatus: "Türstatus",
    backToInstructions: "Zurück zu den Anweisungen",
    loading: "Wird geladen...",
    processing: "Verarbeitung...",
    retryInitialLoad: "Erstladen wiederholen",
    waitingForSession: "Warten auf Sitzungsinformationen...",
    pleaseEnterCode: "Bitte geben Sie einen Code ein",
    codeValidationError: "Fehler bei der Codevalidierung",
    codeValidInNextHours: "Der Code wird in den nächsten Stunden gültig sein",
    connectionError: "Verbindungsfehler mit dem Server",
    forgetSavedCode: "Gespeicherten Code vergessen",
    geolocationNotSupported: "Geolokalisierung wird von Ihrem Browser nicht unterstützt",
    locationAccessError: "Ihr Standort konnte nicht ermittelt werden. Bitte erlauben Sie den Standortzugriff.",
    locationPermissionDenied: "Standortzugriff verweigert. Bitte aktivieren Sie die Standortberechtigungen und versuchen Sie es erneut.",
    locationUnavailable: "Ihr Standort konnte nicht ermittelt werden. Stellen Sie sicher, dass GPS aktiviert ist und ein gutes Signal vorhanden ist.",
    locationTimeout: "Die Standortanfrage ist abgelaufen. Stellen Sie sicher, dass Sie sich an einem Ort mit gutem GPS-Signal befinden, und versuchen Sie es erneut.",
    houseImage: "Haus",
    doorOpenSuccess: "Tür erfolgreich geöffnet",
    doorOpenError: "Fehler beim Öffnen der Tür. Bitte versuchen Sie es erneut.",
    notFinalDoorError: "Dies ist nicht die letzte Tür. Bitte fahren Sie mit den nächsten Schritten fort.",
    sessionContextError: "Haus-ID ist im Sitzungskontext nicht verfügbar.",
    noInfoAvailable: "Keine Informationen verfügbar. Bitte versuchen Sie es erneut."
  },
  // Italiano
  IT: {
    validateCode: "Convalida Codice",
    proceed: "Procedere",
    next: "AVANTI",
    open: "APRIRE",
    enterCode: "Inserisci il codice",
    accessControl: "Controllo Accessi",
    enterAccessCode: "Inserisci il codice di accesso per continuare",
    validating: "Convalida in corso...",
    locationVerification: "Verifica della Posizione",
    verifyingLocation: "Stiamo verificando che tu sia davanti alla porta principale.",
    verifying: "Verifica in corso...",
    doorAccessInstructions: "Istruzioni per l'Accesso alla Porta",
    doorStatus: "Stato della Porta",
    backToInstructions: "Torna alle Istruzioni",
    loading: "Caricamento...",
    processing: "Elaborazione...",
    retryInitialLoad: "Riprova Caricamento Iniziale",
    waitingForSession: "In attesa di informazioni sulla sessione...",
    pleaseEnterCode: "Per favore, inserisci un codice",
    codeValidationError: "Errore durante la convalida del codice",
    codeValidInNextHours: "Il codice sarà valido nelle prossime ore",
    connectionError: "Errore di connessione con il server",
    forgetSavedCode: "Dimentica Codice Salvato",
    geolocationNotSupported: "La geolocalizzazione non è supportata dal tuo browser",
    locationAccessError: "Impossibile ottenere la tua posizione. Per favore, consenti l'accesso alla posizione.",
    locationPermissionDenied: "Accesso alla posizione negato. Per favore, abilita i permessi di localizzazione e riprova.",
    locationUnavailable: "Impossibile determinare la tua posizione. Assicurati che il GPS sia attivo e di avere un buon segnale.",
    locationTimeout: "La richiesta di posizione è scaduta. Assicurati di essere in un luogo con un buon segnale GPS e riprova.",
    houseImage: "Casa",
    doorOpenSuccess: "Porta aperta con successo",
    doorOpenError: "Errore durante l'apertura della porta. Per favore, riprova.",
    notFinalDoorError: "Questa non è la porta finale. Per favore, continua con i passaggi successivi.",
    sessionContextError: "L'ID della casa non è disponibile nel contesto della sessione.",
    noInfoAvailable: "Nessuna informazione disponibile. Per favore, riprova."
  },
  // Português
  PT: {
    validateCode: "Validar Código",
    proceed: "Prosseguir",
    next: "PRÓXIMO",
    open: "ABRIR",
    enterCode: "Digite o código",
    accessControl: "Controle de Acesso",
    enterAccessCode: "Digite o código de acesso para continuar",
    validating: "Validando...",
    locationVerification: "Verificação de Localização",
    verifyingLocation: "Estamos verificando se você está em frente à porta principal.",
    verifying: "Verificando...",
    doorAccessInstructions: "Instruções de Acesso à Porta",
    doorStatus: "Status da Porta",
    backToInstructions: "Voltar às Instruções",
    loading: "Carregando...",
    processing: "Processando...",
    retryInitialLoad: "Tentar Carregamento Inicial Novamente",
    waitingForSession: "Aguardando informações da sessão...",
    pleaseEnterCode: "Por favor, digite um código",
    codeValidationError: "Erro ao validar o código",
    codeValidInNextHours: "O código será válido nas próximas horas",
    connectionError: "Erro de conexão com o servidor",
    forgetSavedCode: "Esquecer Código Salvo",
    geolocationNotSupported: "A geolocalização não é suportada pelo seu navegador",
    locationAccessError: "Não foi possível obter sua localização. Por favor, permita o acesso à localização.",
    locationPermissionDenied: "Acesso à localização negado. Por favor, habilite as permissões de localização e tente novamente.",
    locationUnavailable: "Não foi possível determinar sua localização. Certifique-se de que o GPS está ativado e com bom sinal.",
    locationTimeout: "A solicitação de localização expirou. Certifique-se de estar em um local com bom sinal de GPS e tente novamente.",
    houseImage: "Casa",
    doorOpenSuccess: "Porta aberta com sucesso",
    doorOpenError: "Erro ao abrir a porta. Por favor, tente novamente.",
    notFinalDoorError: "Esta não é a porta final. Por favor, continue com os próximos passos.",
    sessionContextError: "O ID da casa não está disponível no contexto da sessão.",
    noInfoAvailable: "Nenhuma informação disponível. Por favor, tente novamente."
  }
};

// Función para obtener el idioma del navegador
export const getLanguage = (): string => {
  const browserLang = navigator.language.split('-')[0].toUpperCase();
  
  // Verificar si el idioma está soportado, si no, usar inglés como fallback
  return translations[browserLang] ? browserLang : 'EN';
};

// Función para obtener las traducciones según el idioma
export const getTranslations = (): any => {
  const lang = getLanguage();
  return translations[lang];
};

export default translations;
